import { AanmeldenLes } from '../models/AanmeldenLes';
import { Abonnement } from '../models/Abonnementen';
import { AbonnementsVormenByFilter } from '../models/AbonnementsVormenByFilter';
import { ActiviteitLesdagen } from '../models/ActiviteitLesdagen';
import { ActiviteitLessen } from '../models/ActiviteitLessen';
import { ActiviteitSoorten } from '../models/ActiviteitSoorten';
import { Activiteiten } from '../models/Activiteiten';
import { AnonymousAbonnementSummary } from '../models/AnonymousAbonnementSummary';
import { AnonymousLesResult } from '../models/AnonymousLesResult';
import { Authentication } from '../core/authentication';
import { Bezoek } from '../models/Bezoek';
import { BezoekenPerWeek } from '../models/BezoekenPerWeek';
import { BezoekenVanLid } from '../models/BezoekenVanLid';
import { Checkin } from '../models/Checkin';
import { Clubinfo } from '../models/Clubinfo';
import { Cache, Request, RequestOptions } from '../core/data-xs';
import { Drukte } from '../models/Drukte';
import { Factuur } from '../models/Factuur';
import { DeelnemersLes } from '../models/DeelnemersLes';
import { Vestiging } from '../models/Vestiging';
import { Fitscores } from '../models/Fitscores';
import { Fotoboek } from '../models/Fotoboek';
import { GalleryItem } from '../models/GalleryItem';
import { GetFilteredOptions } from '../models/GetFilteredOptions';
import { GlobalService } from './global.service';
import { Injectable } from '@angular/core';
import { Leeg } from '../models/Leeg';
import { LessenReserveren } from '../models/LessenReserveren';
import { Medewerkers } from '../models/Medewerkers';
import { MetadataService } from './metadata.service';
import { Meting } from '../models/Meting';
import { Nieuws } from '../models/Nieuws';
import { StartTijdelijkeStop } from '../models/StartTijdelijkeStop';
import { Tegoed } from '../models/Tegoed';
import { ThemeLiveTiles } from '../models/ThemeLiveTiles';
import { TijdelijkeStopDataVanLid } from '../models/TijdelijkeStopDataVanLid';
import { HttpClient } from '@angular/common/http';
import { ChatGroup } from '../models/ChatGroup';
import { ChatMessage } from '../models/ChatMessages';
import { InstructeurLessen } from '../models/InstructeurLessen';
import { InstructeurLesdagen } from '../models/InstructeurLesdagen';
import { Voedingstip } from '../models/Voedingstips';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Image } from '../models/Image';
import { Product } from '../models/Product';
import { Productgroep } from '../models/Productgroep';
import { WinkelwagenRegel } from '../models/WinkelwagenRegel';
import { Workout } from '../models/Workout';
import { WorkoutOefeningKort } from '../models/WorkoutOefeningKort';
import { WorkoutOefeningVanLid } from '../models/WorkoutOefeningVanLid';
import { WorkoutOefeningIntensiteit } from '../models/WorkoutOefeningIntensiteit';
import { IntensiteitVeld } from '../models/IntensiteitVeld';
import { SearchLid } from '../models/SearchLid';
import { GetTransactieModels } from '../models/GetTransactieModels';
import { Browser } from '@capacitor/browser';
import { ThemeTile } from 'src/app/models/ThemeTile';
// import { TileDataService } from 'src/app/services/tile-data.service';
import { Router } from '@angular/router';
import { AppDebug } from '../core/debug';
import { Addons } from '../models/Addons';
import { Medewerker } from '../models/Medewerker';
import { AnonymousActiviteitInfo } from '../models/AnonymousActiviteitInfo';
import { Oefening } from '../models/Oefening';
import { OnlinePaymentDataContract } from '../models/OnlinePaymentDataContract';
import { CreateAbonnement } from '../models/CreateAbonnement';
import { AankomendeLes } from '../models/AankomendeLes';
import { Opschorting } from '../models/Opschorting';
import { Contactmomenten } from '../models/Contactmomenten';
import { WorkoutSchema } from '../models/WorkoutSchema';
import {
  dedupeWorkoutsById,
} from '../utils/workout-instructor.util';
import { OefeningToevoegen } from '../models/OefeningToevoegen';
import { OefeningGroep } from '../models/OefeningGroep';
import { WrappedData } from '../models/Wrap';
import { Kpi } from '../models/Kpi';
import { Lid } from '../models/Lid';
import { Spaarpunten } from '../models/Spaarpunten';
import { BetalenFactuur } from '../models/BetalenFactuur';
import { Utils } from '../core/utils';

export enum BetaalwijzeEnum {
  Afgerekend,
  Automatische_overschrijving,
  Bankoverschrijving,
  Contant,
  Consumptiekaart,
  Domiciliering,
  Factuur,
  Incasso,
  Pin,
  Via_groep,
  Verrekend,
  Incassobureau,
  iDEAL,
  DirectPay,
  ScheduledPay
}

export enum LesReserverenMode {
  Geen,
  Widget,
  Native
}

export enum ChatMode {
  Geen,
  Widget,
  Native
}

@Injectable({
  providedIn: 'root'
})
export class TileDataService {
  public chats: ChatGroup[];
  private liveTiledataSubject = new ReplaySubject<ThemeLiveTiles>(1);
  private liveTileInterval: any;
  private lastKnownTileData: ThemeLiveTiles;
  private refreshTileSubscription: Subscription;
  /** Occurrence-ids (AankomendeLes.Id) die na afmelden tijdelijk uit Home blijven. */
  private suppressedAankomendeIds = new Set<string>();
  /** Exacte occurrence: LesMomentId/Id + starttijd (voorkomt dat een hele vaste reeks verdwijnt). */
  private suppressedAankomendeOccurrences = new Set<string>();

  private selectedTileCache = new Cache<ThemeTile>("SelectedTile");

  public factuurNummer: Factuur[];
  public galleryString: string;
  public todayDate: Date = new Date();

  /** Locale-safe YYYY-MM-DD without UTC day-shift from toISOString(). */
  private formatLocalDate(datum: Date): string {
    const year = datum.getFullYear();
    const month = String(datum.getMonth() + 1).padStart(2, '0');
    const day = String(datum.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  constructor(private request: Request,
    private metadataService: MetadataService,
    public globalService: GlobalService,
    private http: HttpClient,
    private appDebug: AppDebug,
    private router: Router) { }

  lesmomentId: string;
  /**
   * Haalt live tiledata op en pollt elke 120 seconden.
   */
  public initLiveTiledataWithInterval(): void {
    this.cleanupLiveTileInterval();

    const getDataEvery120Seconds = (): void => {
      this.getLiveTileDataAndNextSubject();

      this.liveTileInterval = setTimeout(() => {
        getDataEvery120Seconds();
      }, 1000 * 120);
    }

    getDataEvery120Seconds();
    this.refreshTileSubscription = this.globalService.getGetNewTiledataSubject().subscribe(() => {
      this.getLiveTileDataAndNextSubject();
    });
  }

  public cleanupLiveTileInterval(): void {
    if (this.liveTileInterval) {
      clearTimeout(this.liveTileInterval);
      this.liveTileInterval = null;
    }
    if (this.refreshTileSubscription) {
      this.refreshTileSubscription.unsubscribe();
      this.refreshTileSubscription = null;
    }
  }

  public lesReserverenMode(): LesReserverenMode {
    var themeTile = this.metadataService.getTilesFromCache().find(tile => tile.Type === "Lessen");
    if (themeTile == undefined) {
      return LesReserverenMode.Geen;
    } else if (themeTile.Url) {
      return LesReserverenMode.Widget;
    } else {
      return LesReserverenMode.Native;
    }
  }

  public chatMode(): ChatMode {
    var themeTile = this.metadataService.getTilesFromCache().find(tile => tile.Type === "Chats");
    if (themeTile == undefined) {
      return ChatMode.Geen;
    } else if (themeTile.Url) {
      return ChatMode.Widget;
    } else {
      return ChatMode.Native;
    }
  }

  public getLiveTileDataSubject(): ReplaySubject<ThemeLiveTiles> {
    return this.liveTiledataSubject;
  }
  
  public setSelectedTile(tile: ThemeTile): void {
    this.selectedTileCache.setItem(tile);
  }

  public getSelectedTileTitle(): string {
    const selectedTile = this.getSelectedTile();
    return selectedTile ? selectedTile.Text : "";
  }

  public getSelectedTile(): ThemeTile | null {
    const tile = this.selectedTileCache.getItem();
    if (!tile) return null;

    tile.VestigingId = tile.ActiviteitId; // De ActiviteitId word in de LFO Manager gebruikt als VestigingId
    return tile;
  }

  public getTegoeden(): Observable<Tegoed[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "GetTegoeden";

    return new Observable<Tegoed[]>((observer) => {
      this.request.SendRequest(options).subscribe((tegoeden) => {
        observer.next(tegoeden);
      });
    });
  }

  public getMedewerkerInstructeur(): Observable<Medewerker> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetMedewerkerByLidId";
    options.params = {
      lidid: Authentication.GetLid().Id
    }
    return new Observable<Medewerker>((observer) => {
      this.request.SendRequest(options).subscribe((medewerkers) => {
        observer.next(medewerkers);
      });
    });
  }

  public addOefeningSet(workoutOefeningId: string): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Workout";
    options.endpoint = "AddOefeningSets";
    options.params = {
      workoutOefeningId: workoutOefeningId
    }
    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((result) => {
        observer.next(result);
      });
    });
  }

  public addSchemaOefeningSet(workoutSchemaOefeningId: string): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Workout";
    options.endpoint = "AddSchemaOefeningSets";
    options.params = {
      workoutSchemaOefeningId: workoutSchemaOefeningId
    }
    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((result) => {
        observer.next(result);
      });
    });
  }

  public deleteSchemaOefeningSet(intensiteitId: string, workoutSchemaOefeningId: string): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Workout";
    options.endpoint = "DeleteSchemaOefeningSet";
    options.data = {
      intensiteitId: intensiteitId,
      workoutSchemaOefeningId: workoutSchemaOefeningId
    }

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((result) => {
        observer.next(result);
      });
    });
  }

  public getHasCategoryOptions(): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetHasCategoryOptions";
    options.params = {
      inschrijfModus: 1
    }
    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((hasCategoryOptions) => {
        observer.next(hasCategoryOptions);
      });
    });
  }

  public getBezoeken(): Observable<Bezoek[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetBezoekenPerWeek";
    options.params = {
      aantalwekenterug: 10,
      lidid: Authentication.GetLid().Id
    };

    return new Observable<Bezoek[]>((observer) => {
      this.request.SendRequest(options).subscribe((bezoeken) => {
        observer.next(bezoeken);
      });
    });
  }

  public getMeasurements(): Observable<Meting[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetMetingenVanLid";
    options.params = {
      lidid: Authentication.GetLid().Id
    };

    return new Observable<Meting[]>((observer) => {
      this.request.SendRequest(options).subscribe((metingen: Meting[]) => {
        metingen = metingen.sort((metingA, metingB): number => {
          return new Date(metingA.Datum).getTime() - new Date(metingB.Datum).getTime();
        });

        observer.next(metingen);
      })
    });
  }

  public getMeasurement(id: string): Observable<Meting> {
    let options = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetMetingVanLid";
    options.params = {
      "metingId": id
    };

    return this.request.SendRequest(options);
  }
  public getLiveTileDataAndNextSubject(): void {
    let options: RequestOptions = new RequestOptions();
    options.controller = "MasterData";
    options.endpoint = "GetLiveTileData2";

    this.request.SendRequest(options, {}, () => { }).subscribe((tileData) => {
      this.lastKnownTileData = this.applyAankomendeSuppression(tileData, true);
      this.liveTiledataSubject.next(this.lastKnownTileData);
    });
  }

  /**
   * Verwijdert één occurrence uit Home "Aankomende lessen".
   * Match alleen op occurrence-id en/of (momentId + start) — nooit op LesMomentId alleen,
   * anders verdwijnt een hele vaste reeks.
   */
  public removeAankomendeLes(
    lesId: string,
    options?: { start?: string | Date; extraIds?: string[]; lesMomentId?: string },
  ): void {
    const occurrenceIds = [lesId, ...(options?.extraIds ?? [])].filter((id) => !!id);
    for (const id of occurrenceIds) {
      this.suppressedAankomendeIds.add(id);
    }

    const startMs = options?.start != null ? new Date(options.start).getTime() : NaN;
    if (Number.isFinite(startMs)) {
      if (options?.lesMomentId) {
        this.suppressedAankomendeOccurrences.add(`${options.lesMomentId}|${startMs}`);
      }
      for (const id of occurrenceIds) {
        this.suppressedAankomendeOccurrences.add(`${id}|${startMs}`);
      }
    }

    if (!this.lastKnownTileData?.AankomendeLessen?.length) {
      this.getLiveTileDataAndNextSubject();
      return;
    }

    this.lastKnownTileData = this.applyAankomendeSuppression(this.lastKnownTileData, false);
    this.liveTiledataSubject.next(this.lastKnownTileData);
    this.getLiveTileDataAndNextSubject();
  }

  /** Maakt suppressie ongedaan na opnieuw aanmelden. */
  public clearAankomendeLesSuppression(
    lesIds?: string[],
    start?: string | Date,
    lesMomentId?: string,
  ): void {
    for (const id of lesIds ?? []) {
      if (id) {
        this.suppressedAankomendeIds.delete(id);
      }
    }

    const startMs = start != null ? new Date(start).getTime() : NaN;
    if (Number.isFinite(startMs)) {
      if (lesMomentId) {
        this.suppressedAankomendeOccurrences.delete(`${lesMomentId}|${startMs}`);
      }
      for (const id of lesIds ?? []) {
        if (id) {
          this.suppressedAankomendeOccurrences.delete(`${id}|${startMs}`);
        }
      }
    }
  }

  private applyAankomendeSuppression(tileData: ThemeLiveTiles, pruneUnused: boolean): ThemeLiveTiles {
    if (
      !tileData?.AankomendeLessen?.length
      || (this.suppressedAankomendeIds.size === 0 && this.suppressedAankomendeOccurrences.size === 0)
    ) {
      return tileData;
    }

    const filtered = tileData.AankomendeLessen.filter((les) => !this.isAankomendeSuppressed(les));
    if (pruneUnused) {
      this.pruneAankomendeSuppressions(tileData.AankomendeLessen);
    }

    if (filtered.length === tileData.AankomendeLessen.length) {
      return tileData;
    }

    return {
      ...tileData,
      AankomendeLessen: filtered,
    };
  }

  private isAankomendeSuppressed(les: AankomendeLes): boolean {
    if (!les) {
      return false;
    }

    // Alleen occurrence-id (niet LesId/LesMomentId alleen).
    if (les.Id && this.suppressedAankomendeIds.has(les.Id)) {
      return true;
    }

    const startMs = les.Start != null ? new Date(les.Start).getTime() : NaN;
    if (!Number.isFinite(startMs)) {
      return false;
    }

    if (les.Id && this.suppressedAankomendeOccurrences.has(`${les.Id}|${startMs}`)) {
      return true;
    }
    if (les.LesId && this.suppressedAankomendeOccurrences.has(`${les.LesId}|${startMs}`)) {
      return true;
    }

    return false;
  }

  private pruneAankomendeSuppressions(lessen: AankomendeLes[]): void {
    const presentIds = new Set<string>();
    const presentOccurrences = new Set<string>();

    for (const les of lessen ?? []) {
      if (les?.Id) {
        presentIds.add(les.Id);
      }
      const startMs = les?.Start != null ? new Date(les.Start).getTime() : NaN;
      if (!Number.isFinite(startMs)) {
        continue;
      }
      if (les.Id) {
        presentOccurrences.add(`${les.Id}|${startMs}`);
      }
      if (les.LesId) {
        presentOccurrences.add(`${les.LesId}|${startMs}`);
      }
    }

    for (const id of Array.from(this.suppressedAankomendeIds)) {
      if (!presentIds.has(id)) {
        this.suppressedAankomendeIds.delete(id);
      }
    }
    for (const key of Array.from(this.suppressedAankomendeOccurrences)) {
      if (!presentOccurrences.has(key)) {
        this.suppressedAankomendeOccurrences.delete(key);
      }
    }
  }

  public getFitscore(): Observable<Fitscores[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetFitscoreVanLid";
    options.params = {
      lidid: Authentication.GetLid().Id
    };

    return new Observable<Fitscores[]>((observer) => {
      this.request.SendRequest(options).subscribe((fitscore: Fitscores[]) => {
        fitscore = fitscore.sort((fitscoreA, fitscoreB): number => {
          return new Date(fitscoreA.Datum).getTime() - new Date(fitscoreB.Datum).getTime();
        });

        observer.next(fitscore);
      })
    });
  }

  public getNieuws(page: number = 1): Observable<Nieuws[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetNieuws_v2";
    options.params = {
      facebookPageName: this.globalService.widgetId ? null : Authentication.GetLid().Id,
      page: page,
    };

    return new Observable((observer) => {
      this.request.SendRequest(options).subscribe((nieuws: Nieuws[]) => {
        nieuws = nieuws.sort((nieuwsA, nieuwsB): number => {
          return new Date(nieuwsA.Datum).getTime() - new Date(nieuwsB.Datum).getTime();
        });
        observer.next(nieuws);
      });
    });
  }

  public getNieuwsById(id: string): Observable<Nieuws> {
    const options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetNieuwsById";
    options.params = {
      id: id
    };

    return this.request.SendRequest(options);
  }

  public getProductGroepen(): Observable<Productgroep[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Shop";
    options.endpoint = "GetProductgroepen";
    options.params = {
      lidid: Authentication.GetLid().Id
    };

    return new Observable<Productgroep[]>((observer) => {
      this.request.SendRequest(options).subscribe((productgroepen: Productgroep[]) => {
        observer.next(productgroepen);
      });
    });
  }

  public getProducten(): Observable<Product[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Shop";
    options.endpoint = "GetProducten";
    options.params = {
      lidid: Authentication.GetLid().Id
    };

    return new Observable<Product[]>((observer) => {
      this.request.SendRequest(options).subscribe((producten: Product[]) => {
        observer.next(producten);
      });
    });
  }

  public getWinkelwagen(): Observable<WinkelwagenRegel[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Shop";
    options.endpoint = "GetWinkelwagen";
    options.params = {
      lidid: Authentication.GetLid().Id
    };

    return new Observable<WinkelwagenRegel[]>((observer) => {
      this.request.SendRequest(options).subscribe((regels: WinkelwagenRegel[]) => {
        observer.next(regels);
      });
    });
  }

  public getBetaalopties(): Observable<BetaalwijzeEnum[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Shop";
    options.endpoint = "LidBetaalopties";
    options.data = {
      lidId: Authentication.GetLid().Id
    };

    return new Observable<BetaalwijzeEnum[]>((observer) => {
      this.request.SendRequest(options).subscribe((betaalopties: BetaalwijzeEnum[]) => {
        observer.next(betaalopties);
      });
    });
  }

  public addToCart(productId: string, aantal: number): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Shop";
    options.endpoint = "WinkelwagenToevoegen";
    options.data = {
      lidId: Authentication.GetLid().Id,
      productId: productId,
      productAantal: aantal
    };

    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe((vorderingId) => {
        observer.next(vorderingId);
      });
    });
  }

  public updateCartAmount(vorderingId: string, nieuwAantal: number): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Shop";
    options.endpoint = "WinkelwagenAantalBijwerken";
    options.data = {
      id: vorderingId,
      nieuwAantal: nieuwAantal
    };

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((result) => {
        observer.next(result);
      });
    });
  }

  public getBestellingen(lidid: string): Observable<WinkelwagenRegel[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Shop";
    options.endpoint = "GetBestellingen";
    options.params = {
      lidid: lidid
    };

    return new Observable<WinkelwagenRegel[]>((observer) => {
      this.request.SendRequest(options).subscribe((result) => {
        observer.next(result);
      });
    });
  }

  public updateSpaarpunten(punten: number): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Lid";
    options.endpoint = "UpdateSpaarpuntenShop";
    options.params = {
      spaarpunten: punten
    };

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((result) => {
        observer.next(result);
      });
    });
  }

  public deleteCartItem(vorderingId: string): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Shop";
    options.endpoint = "WinkelwagenVerwijderRegel";
    options.data = {
      id: vorderingId
    };

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((result) => {
        observer.next(result === true || result === 'true' || result === 1 || result === '1');
      });
    });
  }

  public emptyCart(): Observable<number> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Shop";
    options.endpoint = "WinkelwagenLegen";
    options.data = {
      lidId: Authentication.GetLid().Id
    };

    return new Observable<number>((observer) => {
      this.request.SendRequest(options).subscribe((rowsRemoved) => {
        observer.next(rowsRemoved);
      });
    });
  }

  /**
   * Maak een factuurnummer aan voor de winkelwagen.
   * @param incasso Betaalwijze incasso. Gebruik false voor een multisafepay (iDeal) betaling.
   * @returns Een observable die het factuurnummer ontvangt.
  */
  public factureerWinkelwagen(incasso: boolean, puntenGebruiken: boolean, usedSpaarpunten: number): Observable<number> {
    const options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Shop";
    options.endpoint = "FactureerWinkelwagen";
    options.data = {
      lidId: this.globalService.getLid()!.Id,
      incasso: incasso,
      puntenGebruiken: puntenGebruiken,
      usedSpaarpunten: usedSpaarpunten
    };

    return this.request.SendRequest(options)
  }

  public betaalFactuur(factuurnummer: string, vorderingId: string): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Lid";
    options.endpoint = "BetalenFactuur";
    options.params = {
      factuurNummer: factuurnummer,
      vorderingId: vorderingId
    };

    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe((mspUrl: string) => {
        observer.next(mspUrl);
      });
    });
  }

  public betaalFactuur_V2(factuurnummer: string, vorderingId: string): Observable<BetalenFactuur> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Lid";
    options.endpoint = "BetalenFactuur_V2";
    options.params = {
      factuurNummer: factuurnummer,
      vorderingId: vorderingId
    };

    return new Observable<BetalenFactuur>((observer) => {
      this.request.SendRequest(options).subscribe((result: BetalenFactuur) => {
        observer.next(result);
      });
    });
  }

  public betalenShop(factuurnummer: string, vorderingId: string): Observable<BetalenFactuur> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Lid";
    options.endpoint = "BetalenShop";
    options.params = {
      factuurNummer: factuurnummer,
      vorderingId: vorderingId
    };

    return new Observable<BetalenFactuur>((observer) => {
      this.request.SendRequest(options).subscribe((result: BetalenFactuur) => {
        observer.next(result);
      });
    });
  }

  public toggleTag(id: string): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Tag";
    options.endpoint = "ToggleTag";
    options.data = {
      lidId: Authentication.GetLid().Id,
      elementId: id,
      type: 1
    };

    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe((success: string) => {
        observer.next(success);
      });
    });
  }

  public GetTagExists(id: string): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Tag";
    options.endpoint = "GetTagExists";
    options.params = {
      lidId: Authentication.GetLid().Id,
      elementId: id,
      type: 1
    };

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((exists: boolean) => {
        observer.next(exists);
      });
    });
  }

  public getLikeCount(id: string): Observable<number> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Tag";
    options.endpoint = "GetLikeCount";
    options.params = {
      elementId: id
    };

    return new Observable<number>((observer) => {
      this.request.SendRequest(options).subscribe((count: number) => {
        observer.next(count);
      });
    });
  }

  public getWorkoutsVanLid(datum): Observable<Workout[]> {
    return this.getWorkoutsVanLidByLid(Authentication.GetLid().Id, datum);
  }

  public getWorkoutsVanLidByLid(lidId: string, datum: Date): Observable<Workout[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutsVanLid";
    options.params = {
      lidId: lidId,
      datum: datum ? this.formatLocalDate(datum) : undefined
    };

    return new Observable<Workout[]>((observer) => {
      this.request.SendRequest(options).subscribe({
        next: (workouts: Workout[]) => {
          observer.next(dedupeWorkoutsById(workouts ?? []));
          observer.complete();
        },
        error: (err) => observer.error(err),
      });
    });
  }

  public getWorkoutsVanLidInstructeur(lidId: string): Observable<Workout[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutsVanLidInstructeur";
    options.params = {
      lidId: lidId
    };

    return new Observable<Workout[]>((observer) => {
      this.request.SendRequest(options).subscribe((workouts: Workout[]) => {
        observer.next(workouts);
      });
    });
  }

  /**
   * Workouts op een dag voor een specifiek lid (instructeur-vriendelijke auth).
   * Zelfde data als GetWorkoutsVanLid (datumfilter + voortgang), maar authorized op eigen logifitid.
   */
  public getWorkoutById(lidId: string, datum: Date): Observable<Workout[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutById";
    options.params = {
      lidId: lidId,
      datum: datum && [datum.getFullYear(), datum.getMonth() + 1, datum.getDate()].join("-")
    };

    return new Observable<Workout[]>((observer) => {
      this.request.SendRequest(options).subscribe((workouts: Workout[]) => {
        observer.next(dedupeWorkoutsById(workouts ?? []));
      });
    });
  }

  /** Workouts op een dag voor een specifiek lid (instructeur-coaching). */
  public getWorkoutsVanLidForLid(lidId: string, datum: Date): Observable<Workout[]> {
    return this.getWorkoutById(lidId, datum);
  }

  /** Dagen met geplande oefeningen voor een specifiek lid (instructeur-coaching). */
  public getWorkoutOefeningDagenVanLidForLid(lidId: string, datum: Date): Observable<Date[]> {
    return this.getWorkoutOefeningDagenVanLidByLid(lidId, datum);
  }

  public getWorkoutsById(lidId: string): Observable<Workout[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Lid";
    options.endpoint = "GetWorkoutsById";
    options.params = {
      lidId: lidId
    };

    return new Observable<Workout[]>((observer) => {
      this.request.SendRequest(options).subscribe((workouts: Workout[]) => {
        observer.next(workouts);
      });
    });
  }

  public getVorderingenById(lidId: string) {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Lid";
    options.endpoint = "GetVorderingenById";
    options.params = {
      lidId: lidId
    };

    return new Observable<Workout[]>((observer) => {
      this.request.SendRequest(options).subscribe((workouts: Workout[]) => {
        observer.next(workouts);
      });
    });
  }

  public getWorkoutSchemas(workoutDoel: string, workoutLevel: string, searchText: string): Observable<WorkoutSchema[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutSchemas";
    options.params = {
      workoutDoel: workoutDoel,
      workoutLevel: workoutLevel,
      searchText: searchText
    };

    return new Observable<WorkoutSchema[]>((observer) => {
      this.request.SendRequest(options).subscribe((workoutSchemas: WorkoutSchema[]) => {
        observer.next(workoutSchemas);
      });
    });
  }

  public GetWorkoutSchemasInclusiefPersoonlijk(workoutDoel: string, workoutLevel: string, searchText: string, lidId: string | null): Observable<WorkoutSchema[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutSchemasInclusiefPersoonlijk";
    options.params = {
      workoutDoel: workoutDoel,
      workoutLevel: workoutLevel,
      searchText: searchText,
      lidId: lidId
    };

    return new Observable<WorkoutSchema[]>((observer) => {
      this.request.SendRequest(options).subscribe((workoutSchemas: WorkoutSchema[]) => {
        observer.next(workoutSchemas);
      });
    });
  }

  public getContactmomentenById(lidId: string) {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Lid";
    options.endpoint = "GetContactmomentenById";
    options.params = {
      lidId: lidId
    };

    return new Observable<Contactmomenten[]>((observer) => {
      this.request.SendRequest(options).subscribe((contactmomenten: Contactmomenten[]) => {
        observer.next(contactmomenten);
      });
    });
  }

  public getOpschortingenById(lidId: string) {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Lid";
    options.endpoint = "GetOpschortingenById";
    options.params = {
      lidId: lidId
    };

    return new Observable<Opschorting[]>((observer) => {
      this.request.SendRequest(options).subscribe((opschortingen: Opschorting[]) => {
        observer.next(opschortingen);
      });
    });
  }

  public getWorkoutSchemaById(schemaId: string): Observable<WorkoutSchema> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutSchemaById";
    options.params = {
      schemaId: schemaId
    };

    return new Observable<WorkoutSchema>((observer) => {
      this.request.SendRequest(options).subscribe((workoutSchema: WorkoutSchema) => {
        observer.next(workoutSchema);
      });
    });
  }

  public getOefeningById(id: string): Observable<OefeningToevoegen> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetOefeningById";
    options.params = {
      oefeningId: id
    };

    return new Observable<OefeningToevoegen>((observer) => {
      this.request.SendRequest(options).subscribe((oefening: OefeningToevoegen) => {
        observer.next(oefening);
      });
    });
  }

  public getDoelen(): Observable<OefeningGroep[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutDoelen";

    return new Observable<OefeningGroep[]>((observer) => {
      this.request.SendRequest(options).subscribe((doelen: OefeningGroep[]) => {
        observer.next(doelen);
      });
    });
  }

  public getLevels(): Observable<OefeningGroep[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutLevels";

    return new Observable<OefeningGroep[]>((observer) => {
      this.request.SendRequest(options).subscribe((doelen: OefeningGroep[]) => {
        observer.next(doelen);
      });
    });
  }
  public getWorkoutOefeningDagenVanLid(datum): Observable<Date[]> {
    return this.getWorkoutOefeningDagenVanLidByLid(Authentication.GetLid().Id, datum);
  }

  public getWorkoutOefeningDagenVanLidByLid(lidId: string, datum: Date): Observable<Date[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutOefeningDagenVanLid";
    options.params = {
      lidId: lidId,
      datum: datum ? this.formatLocalDate(datum) : undefined
    };

    return new Observable<Date[]>((observer) => {
      this.request.SendRequest(options).subscribe({
        next: (oefeningDatums: string[]) => {
          const oefeningDatumObjects: Date[] = [];
          for (let oefeningDatum of oefeningDatums ?? []) {
            oefeningDatumObjects.push(new Date(oefeningDatum));
          }
          observer.next(oefeningDatumObjects);
          observer.complete();
        },
        error: (err) => observer.error(err),
      });
    });
  }

  public getWorkoutOefeningen(workoutId: string): Observable<WorkoutOefeningKort[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutOefeningen";
    options.params = {
      workoutId: workoutId,
      workoutSelectedDate: this.globalService.workoutsCurrentDate.toISOString()
    };

    return new Observable<WorkoutOefeningKort[]>((observer) => {
      this.request.SendRequest(options).subscribe((workoutOefeningen: WorkoutOefeningKort[]) => {
        observer.next(workoutOefeningen);
      });
    });
  }

  public getAlleWorkoutOefeningen(workoutId: string, page: number): Observable<WorkoutOefeningKort[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetAlleWorkoutOefeningen";
    options.params = {
      workoutId: workoutId,
      page: page
    };

    return new Observable<WorkoutOefeningKort[]>((observer) => {
      this.request.SendRequest(options).subscribe((workoutOefeningen: WorkoutOefeningKort[]) => {
        observer.next(workoutOefeningen);
      });
    });
  }

  public getWorkoutOefeningenDetail(workoutId: string, datum: Date): Observable<WorkoutOefeningKort[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutOefeningen";
    options.params = {
      workoutId: workoutId,
      workoutSelectedDate: datum.toISOString()
    };

    return new Observable<WorkoutOefeningKort[]>((observer) => {
      this.request.SendRequest(options).subscribe((workoutOefeningen: WorkoutOefeningKort[]) => {
        observer.next(workoutOefeningen);
      });
    });
  }

  public getWorkoutOefeningenWithIntensiteiten(workoutId: string, datum: Date): Observable<WorkoutOefeningKort[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutOefeningenWithIntensiteiten";
    options.params = {
      workoutId: workoutId,
      workoutSelectedDate: datum.toISOString()
    };

    return new Observable<WorkoutOefeningKort[]>((observer) => {
      this.request.SendRequest(options).subscribe({
        next: (workoutOefeningen: WorkoutOefeningKort[]) => {
          observer.next(workoutOefeningen);
          observer.complete();
        },
        error: (err) => observer.error(err),
      });
    });
  }

  public getWorkoutSchemaOefeningen(workoutId: string): Observable<WorkoutOefeningKort[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutSchemaOefeningen";
    options.params = {
      workoutId: workoutId
    };

    return new Observable<WorkoutOefeningKort[]>((observer) => {
      this.request.SendRequest(options).subscribe((workoutSchemaOefeningen: WorkoutOefeningKort[]) => {
        observer.next(workoutSchemaOefeningen);
      });
    });
  }

  public getWorkoutSchemaOefeningenBySchema(workoutId: string): Observable<WorkoutOefeningKort[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutSchemaOefeningenBySchema";
    options.params = {
      workoutSchemaId: workoutId
    };

    return new Observable<WorkoutOefeningKort[]>((observer) => {
      this.request.SendRequest(options).subscribe((workoutSchemaOefeningen: WorkoutOefeningKort[]) => {
        observer.next(workoutSchemaOefeningen);
      });
    });
  }

  public getWorkoutSchemaOefeningenById(workoutId: string, oefeningId: string): Observable<WorkoutOefeningKort> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutSchemaOefeningenById";
    options.params = {
      workoutSchemaId: workoutId,
      oefeningId: oefeningId
    };

    return new Observable<WorkoutOefeningKort>((observer) => {
      this.request.SendRequest(options).subscribe((workoutSchemaOefeningen: WorkoutOefeningKort) => {
        observer.next(workoutSchemaOefeningen);
      });
    });
  }

  public addWorkoutSchema(schemaOptions: { LidId: string, SchemaId: string, StartDatum: Date, AantalKeerPerWeek: number, AantalWeken: number, Maandag: boolean, Dinsdag: boolean, Woensdag: boolean, Donderdag: boolean, Vrijdag: boolean, Zaterdag: boolean, Zondag: boolean }): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "AddWorkoutSchemaDoorlopend";
    options.data = schemaOptions;

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public updateWorkoutSchema(schemaOptions: {
    LidId: string, SchemaId: string,
    StartDatum: Date, AantalKeerPerWeek: number, AantalWeken: number, Maandag: boolean, Dinsdag: boolean,
    Woensdag: boolean, Donderdag: boolean, Vrijdag: boolean, Zaterdag: boolean, Zondag: boolean, Naam: string,
    Rust: number | null, Reps1: number | null, Reps2: number | null, Reps3: number | null, Reps4: number | null, Reps5: number | null, Reps6: number | null
  }): Observable<boolean> {
    const options = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "UpdateWorkoutSchemaDoorlopend";
    options.data = schemaOptions;

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public updateWorkoutSchemaDetails(schemaOptions: {
    LidId: string, SchemaId: string,
    Naam: string, Rust: number | null, Reps1: number | null, Reps2: number | null, Reps3: number | null, Reps4: number | null, Reps5: number | null, Reps6: number | null
  }): Observable<boolean> {
    const options = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "UpdateWorkoutDetails";
    options.data = schemaOptions;

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public createWorkoutSchema(): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "CreateWorkoutSchema";

    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe((schemaId: string) => {
        observer.next(schemaId);
      });
    });
  }

  public createWorkoutSchemaInstructeur(lidId: string): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "CreateWorkoutSchemaInstructeur";
    options.params = {
      lidId: lidId
    };

    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe((schemaId: string) => {
        observer.next(schemaId);
      });
    });
  }

  public deleteWorkoutSchemaOefening(workoutSchemaOefeningId: string, workoutId: string): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "DeleteWorkoutSchemaOefening";
    options.data = {
      SchemaOefeningId: workoutSchemaOefeningId,
      WorkoutId: workoutId
    };


    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public deleteWorkoutOefening(workoutOefeningId: string): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "DeleteWorkoutOefening";
    options.data = {
      OefeningId: workoutOefeningId
    };

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public stopWorkout(workoutId: string): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "WorkoutBeeindigen";
    options.data = {
      workoutId: workoutId
    };

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public deleteWorkout(workoutId: string): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "DeleteWorkout";
    options.data = {
      WorkoutId: workoutId
    };

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public GetWorkoutOefeningDetails(workoutOefeningId: string): Observable<WorkoutOefeningVanLid> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutOefeningDetails";
    options.params = {
      workoutOefeningId: workoutOefeningId
    };

    return new Observable<WorkoutOefeningVanLid>((observer) => {
      this.request.SendRequest(options).subscribe((workoutOefening: WorkoutOefeningVanLid) => {
        observer.next(workoutOefening);
      });
    });
  }

  public GetWorkoutOefeningIntensiteiten(workoutOefeningId: string): Observable<WorkoutOefeningIntensiteit[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutOefeningIntensiteiten";
    options.params = {
      workoutOefeningId: workoutOefeningId
    };

    return new Observable<WorkoutOefeningIntensiteit[]>((observer) => {
      this.request.SendRequest(options).subscribe((intensiteiten: WorkoutOefeningIntensiteit[]) => {
        observer.next(intensiteiten);
      });
    });
  }

  public GetWorkoutOefeningIntensiteitVelden(workoutOefeningId: string): Observable<IntensiteitVeld[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutOefeningIntensiteitVelden";
    options.params = {
      workoutOefeningId: workoutOefeningId
    };

    return new Observable<IntensiteitVeld[]>((observer) => {
      this.request.SendRequest(options).subscribe((velden: IntensiteitVeld[]) => {
        observer.next(velden);
      });
    });
  }

  public GetWorkoutSchemaOefeningDetails(workoutSchemaOefeningId: string): Observable<WorkoutOefeningVanLid> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutSchemaOefeningDetails";
    options.params = {
      workoutSchemaOefeningId: workoutSchemaOefeningId
    };

    return new Observable<WorkoutOefeningVanLid>((observer) => {
      this.request.SendRequest(options).subscribe((workoutOefening: WorkoutOefeningVanLid) => {
        observer.next(workoutOefening);
      });
    });
  }

  public GetWorkoutSchemaOefeningIntensiteiten(workoutSchemaOefeningId: string): Observable<WorkoutOefeningIntensiteit[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutSchemaOefeningIntensiteiten";
    options.params = {
      workoutSchemaOefeningId: workoutSchemaOefeningId
    };

    return new Observable<WorkoutOefeningIntensiteit[]>((observer) => {
      this.request.SendRequest(options).subscribe((intensiteiten: WorkoutOefeningIntensiteit[]) => {
        observer.next(intensiteiten);
      });
    });
  }

  public GetWorkoutSchemaOefeningIntensiteitVelden(workoutSchemaOefeningId: string): Observable<IntensiteitVeld[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "GetWorkoutSchemaOefeningIntensiteitVelden";
    options.params = {
      workoutSchemaOefeningId: workoutSchemaOefeningId
    };

    return new Observable<IntensiteitVeld[]>((observer) => {
      this.request.SendRequest(options).subscribe((velden: IntensiteitVeld[]) => {
        observer.next(velden);
      });
    });
  }

  public WorkoutSetVoltooid(workoutOefeningId: string, voltooid: boolean): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "SetWorkoutOefeningVoltooid";
    options.params = {
      workoutOefeningId: workoutOefeningId,
      voltooid: voltooid
    };

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public UpdateWorkoutIntensiteiten(intensiteiten: { id: string, velden: { name: string, value: string }[] }[]): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "UpdateWorkoutIntensiteiten";
    options.data = intensiteiten;

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public UpdateWorkoutSchemaIntensiteiten(intensiteiten: { schemaOefeningId: string, id: string, velden: { name: string, value: string }[] }[]): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Workout";
    options.endpoint = "UpdateWorkoutSchemaIntensiteiten";
    options.data = intensiteiten;

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public GetGalleryItemsByGalleryIdNieuws(galleryId: string): Observable<GalleryItem[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetGalleryItemsByGalleryId";
    options.params = {
      galleryId: galleryId
    };

    return new Observable<GalleryItem[]>((observer) => {
      this.request.SendRequest(options).subscribe((galleryitem) => {
        observer.next(galleryitem);
      });
    });
  }

  public getCheckin(): Observable<Checkin[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Abonnement";
    options.endpoint = "GetAbonnementenByLidId";
    options.params = {
      lidId: Authentication.GetLid().Id
    };

    return new Observable<Checkin[]>((observer) => {
      this.request.SendRequest(options).subscribe((checkin: Checkin[]) => {
        checkin = checkin.sort((checkinA, checkinB): number => {
          return new Date(checkinA.Einddatum).getTime() - new Date(checkinB.Einddatum).getTime();
        });
        observer.next(checkin);
      })
    });
  }

  public getOneOffToken(onsucces: (result) => any): void {
    let options = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetOneOffToken";

    this.request.SendRequest(options).subscribe(result => {
      if (onsucces) {
        onsucces(result);
      }
    });
  }

  public getMedewerkers(page: number = 1): Observable<Medewerkers[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetMedewerkers";
    options.params = {
      LidId: Authentication.GetLid().Id,
      page: page
    };

    return new Observable<Medewerkers[]>((observer) => {
      this.request.SendRequest(options).subscribe((medewerkers) => {
        observer.next(medewerkers);
      });
    });
  }

  public getActiviteitInfo(page: number = 1): Observable<AnonymousActiviteitInfo[]> {
    const options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetActiviteitInfo";
    options.params = { page };

    return this.request.SendRequest(options);
  }

  public getClubinfo(lidId: string | null = null): Observable<Clubinfo[]> {
    const options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "GeneralClubInformation";
    options.endpoint = "GetClubInfo";

    if (lidId) {
      options.params = {
        lidid: lidId
      };
    }

    return new Observable<Clubinfo[]>((observer) => {
      this.request.SendRequest(options).subscribe((clubinfo) => {
        observer.next(clubinfo);
      });
    });
  }

  public getFactuur(): Observable<Factuur[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetPaymentHistory";
    options.params = {
      LidId: Authentication.GetLid().Id
    };

    return new Observable<Factuur[]>((observer) => {
      this.request.SendRequest(options).subscribe((factuur) => {
        observer.next(factuur);
      });
    });
  }

  public getEmailFactuur(factuurNummer: string): Observable<string> {

    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetFactuur2";
    options.params = {
      factuurnummer: factuurNummer
    };
    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe();
    });
  }

  public getAbonnementenVanLid(): Observable<Abonnement[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Abonnement";
    options.endpoint = "GetAbonnementenVanLid";

    return new Observable<Abonnement[]>((observer) => {
      this.request.SendRequest(options).subscribe((abonnementen) => {
        observer.next(abonnementen);
      });
    });
  }

  public getAbonnementenById(lidId: string): Observable<Abonnement[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetAbonnementenById";
    options.params = {
      lidId: lidId
    };

    return new Observable<Abonnement[]>((observer) => {
      this.request.SendRequest(options).subscribe((abonnementen) => {
        observer.next(abonnementen);
      });
    });
  }

  public getAddonsVanLid(): Observable<Addons[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Abonnement";
    options.endpoint = "GetAddonsVanLid";

    return new Observable<Addons[]>((observer) => {
      this.request.SendRequest(options).subscribe((addons) => {
        observer.next(addons);
      });
    });
  }

  public getTijdelijkeStopDataVanLid(): Observable<TijdelijkeStopDataVanLid> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetTijdelijkeStopDataVanLid";

    return new Observable<TijdelijkeStopDataVanLid>((observer) => {
      this.request.SendRequest(options).subscribe((tijdelijkeStopData) => {
        observer.next(tijdelijkeStopData);
      });
    });
  }

  public updateTijdelijkeStopData(): Observable<StartTijdelijkeStop> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "WijzigTijdelijkeStop";

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    options.data = {
      LidId: Authentication.GetLid().Id,
      StartDatum: this.globalService.tijdelijkeStopData.Start,
      EindDatum: tomorrow,
      Reden: ""
    };

    return new Observable<StartTijdelijkeStop>((observer) => {
      this.request.SendRequest(options).subscribe((tijdelijkeStopData) => {
        observer.next(tijdelijkeStopData);
      });
    });
  }

  public GetAbonnementsVormenByFilter(filter: any = null): Observable<AbonnementsVormenByFilter[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetAbonnementsVormenByFilter";
    if (filter == null) {
      options.data = {
        category1Id: this.globalService.cat1,
        category2Id: this.globalService.cat2,
        category3Id: this.globalService.cat3,
        InschrijfModus: 1,
        leeftijd: 0,
        lidId: Authentication.GetLid().Id,
        vestigingsId: Authentication.GetLid().Vestiging_IdValue,
      };
    } else {
      options.data = filter;
    }

    return new Observable<AbonnementsVormenByFilter[]>((observer) => {
      this.request.SendRequest(options).subscribe((vormenByFilter) => {
        observer.next(vormenByFilter);
      });
    });
  }

  public StartTijdelijkeStop(): Observable<StartTijdelijkeStop> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "StartTijdelijkeStop";
    options.successMessage = "Opschorting toegepast";
    options.data = {
      EindDatum: this.globalService.tijdelijkeStopTot,
      LidId: Authentication.GetLid().Id,
      Reden: this.globalService.tijdelijkeStopReden,
      StartDatum: this.globalService.tijdelijkeStopVan
    }

    return new Observable<StartTijdelijkeStop>((observer) => {
      this.request.SendRequest(options, null, (err) => {
        if (err) {
          observer.error(err);
        }
      }).subscribe((tijdelijkeStopData) => {
        observer.next(tijdelijkeStopData);
      });
    });
  }

  public getVoedingsTips(page: number = 1): Observable<Voedingstip[]> {
    const options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetVoedingsTips";
    options.params = {
      LidId: Authentication.GetLid()!.Id,
      page: page
    };

    return new Observable<Voedingstip[]>((observer) => {
      this.request.SendRequest(options).subscribe((voedingstips) => {
        observer.next(voedingstips);
      });
    });
  }

  public getVoedingstipById(id: string): Observable<Voedingstip> {
    const options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetVoedingstipById";
    options.params = {
      id: id
    };

    return this.request.SendRequest(options);
  }

  public getBezoekenVanLid(): Observable<BezoekenVanLid[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetBezoekenVanLid";
    options.params = {
      aantalwekenterug: "12",
      lidid: Authentication.GetLid().Id
    };

    return new Observable<BezoekenVanLid[]>((observer) => {
      this.request.SendRequest(options).subscribe((bezoeken) => {
        observer.next(bezoeken);
      })
    })
  }

  public getBezoekenById(lidId: string): Observable<BezoekenVanLid[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetBezoekenById";
    options.params = {
      aantalwekenterug: "12",
      lidid: lidId
    };

    return new Observable<BezoekenVanLid[]>((observer) => {
      this.request.SendRequest(options).subscribe((bezoeken) => {
        observer.next(bezoeken);
      })
    })
  }

  public getBezoekenPerWeek(): Observable<BezoekenPerWeek[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetBezoekenPerWeek";
    options.params = {
      aantalwekenterug: "10",
      lidid: Authentication.GetLid().Id
    };

    return new Observable<BezoekenPerWeek[]>((observer) => {
      this.request.SendRequest(options).subscribe((bezoekenPerWeek) => {
        observer.next(bezoekenPerWeek);
      })
    })
  }

  public getOefeningen(page: number = 1): Observable<Oefening[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetOefeningen";
    options.params = {
      page: page
    };

    return new Observable<Oefening[]>((observer) => {
      this.request.SendRequest(options).subscribe((oefeningen) => {
        observer.next(oefeningen);
      });
    });
  }

  public getOefeningenBySearch(page: number = 1, searchResult: string = "", oefeningGroepId: string = "", oefeningTypeId: string = ""): Observable<OefeningToevoegen[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Workout";
    options.endpoint = "SearchOefeningen";
    options.params = {
      page: page,
      searchResult: searchResult,
      oefeningsGroep: oefeningGroepId,
      oefeningsType: oefeningTypeId
    };

    return new Observable<OefeningToevoegen[]>((observer) => {
      this.request.SendRequest(options).subscribe((oefeningen) => {
        observer.next(oefeningen);
      });
    });
  }

  public addWorkoutOefening(workoutId: string, workoutOefeningId: string, datum: string): Observable<any> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Workout";
    options.endpoint = "AddWorkoutOefening";
    options.successMessage = "Oefening toegevoegd";
    options.params = {
      workoutId: workoutId,
      workoutOefeningId: workoutOefeningId,
      datum: datum
    };

    return new Observable<any>((observer) => {
      this.request.SendRequest(options).subscribe((oefeningen) => {
        observer.next(oefeningen);
      });
    });
  }

  public addWorkoutSchemaOefening(workoutId: string, workoutOefeningId: string, dag: string): Observable<any> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Workout";
    options.endpoint = "AddWorkoutSchemaOefening";
    options.successMessage = "Oefening toegevoegd";
    options.params = {
      workoutId: workoutId,
      workoutOefeningId: workoutOefeningId,
      dag: dag
    };

    return new Observable<any>((observer) => {
      this.request.SendRequest(options).subscribe((oefeningen) => {
        observer.next(oefeningen);
      });
    });
  }

  public getOefeningGroepen(oefeningTypeId: string): Observable<OefeningGroep[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Workout";
    options.endpoint = "GetOefeningsGroepen";
    options.params = {
      oefeningTypeId: oefeningTypeId
    };

    return new Observable<OefeningGroep[]>((observer) => {
      this.request.SendRequest(options).subscribe((oefeningen: OefeningGroep[]) => {
        observer.next(oefeningen);
      });
    });
  }

  public getOefeningTypes(): Observable<OefeningGroep[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Workout";
    options.endpoint = "GetOefeningsTypes";

    return new Observable<OefeningGroep[]>((observer) => {
      this.request.SendRequest(options).subscribe((oefeningTypes: OefeningGroep[]) => {
        observer.next(oefeningTypes);
      });
    });
  }

  public getFotoboek(page: number = 1): Observable<Fotoboek[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetFotoboek";
    options.params = { page };

    return new Observable((observer) => {
      this.request.SendRequest(options).subscribe((fotoboek) => {
        observer.next(fotoboek);
      });
    });
  }

  public getFotoboekById(id: string): Observable<Fotoboek> {
    const options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetFotoboekById";
    options.params = {
      id: id
    };

    return this.request.SendRequest(options);
  }

  public GetGalleryItemsByGalleryId(galleryId: string): Observable<GalleryItem[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetGalleryItemsByGalleryId";
    options.params = {
      galleryId: galleryId
    };

    return new Observable<GalleryItem[]>((observer) => {
      this.request.SendRequest(options).subscribe((galleryitem) => {
        observer.next(galleryitem);
      });
    });
  }

  public getDrukteWidget(): Observable<Drukte[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetDrukteVoorWidget";
    options.params = {
      widgetId: "9BC30655-002E-4BA6-8A09-D8BCE58D09A0"
    };

    return new Observable<Drukte[]>((observer) => {
      this.request.SendRequest(options).subscribe((drukte) => {
        observer.next(drukte);
      });
    });
  }

  public getLessenReserverenResult(): Observable<LessenReserveren> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "GetLessenReserverenResult";
    options.params = {
      datum: "2021-12-19T14:40:45.307Z",
      vestigingId: ""
    }
    return new Observable<LessenReserveren>((observer) => {
      this.request.SendRequest(options).subscribe((lessenreserveren) => {
        observer.next(lessenreserveren);
      });
    });
  }

  public getActiviteitsoorten(vestiging: string | null): Observable<ActiviteitSoorten[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lessen";
    options.endpoint = "GetActiviteitsoorten";
    options.params = {
      vestiging: vestiging
    }
    return new Observable<ActiviteitSoorten[]>((observer) => {
      this.request.SendRequest(options).subscribe((vestiging) => {
        observer.next(vestiging);
      });
    });
  }

  public getAankomendeLessen(): Observable<ActiviteitLessen[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "GetAankomendeLessen";

    return new Observable<ActiviteitLessen[]>((observer) => {
      this.request.SendRequest(options).subscribe((aankomendeLessen) => {
        observer.next(aankomendeLessen);
      });
    });
  }

  public getVestigingen(): Observable<Vestiging[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetVestigingen";

    return new Observable<Vestiging[]>((observer) => {
      this.request.SendRequest(options).subscribe((vestiging) => {
        observer.next(vestiging);
      });
    });
  }
  
  public getVestigingenLeads(): Observable<Vestiging[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetVestigingen";

    return new Observable<Vestiging[]>((observer) => {
      this.request.SendRequest(options).subscribe((vestiging) => {
        observer.next(vestiging);
      });
    });
  }

  public getActiviteiten(vestiging: string | null, activiteitsoort: string | null, activiteit: string | null): Observable<Activiteiten[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lessen";
    options.endpoint = "GetActiviteiten";
    options.params = {
      vestiging: vestiging,
      activiteitsoort: activiteitsoort,
      activiteit: activiteit
    }
    return new Observable<Activiteiten[]>((observer) => {
      this.request.SendRequest(options).subscribe((activiteiten) => {
        observer.next(activiteiten);
      });
    });
  }

  public getActiviteitLessen(vestiging: string | null, activiteitsoort: string | null, activiteit: string | null, datum: Date): Observable<ActiviteitLessen[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "GetActiviteitLessen";
    options.params = {
      vestiging: vestiging,
      activiteitsoort: activiteitsoort,
      activiteit: activiteit,
      datum: new Date(datum.getTime() - (datum.getTimezoneOffset() * 60000)).toISOString()
    }
    return new Observable<ActiviteitLessen[]>((observer) => {
      this.request.SendRequest(options).subscribe((activiteiten) => {
        observer.next(activiteiten);
      });
    });
  }

  public getActiviteitLesdagen(vestiging: string | null, activiteitsoort: string | null, activiteit: string | null, datum: Date): Observable<ActiviteitLesdagen[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "GetActiviteitLesdagenHuidigeWeek";
    options.params = {
      vestiging: vestiging,
      activiteitsoort: activiteitsoort,
      activiteit: activiteit,
      datum: new Date(datum.getTime() - (datum.getTimezoneOffset() * 60000)).toISOString()
    }
    return new Observable<ActiviteitLesdagen[]>((observer) => {
      this.request.SendRequest(options).subscribe((activiteiten) => {
        observer.next(activiteiten);
      });
    });
  }

  public getLes(lesid: string): Observable<ActiviteitLessen> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "GetLes";
    options.params = {
      les: lesid
    };

    return new Observable<ActiviteitLessen>((observer) => {
      this.request.SendRequest(options).subscribe((les) => {
        observer.next(les);
      });
    });
  }

  public getInstructeurLesdagen(datum: Date): Observable<InstructeurLesdagen[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "GetInstructeurLesdagen_v3";
    options.params = {
      datum: datum.toISOString()
    };

    return new Observable<InstructeurLesdagen[]>((observer) => {
      this.request.SendRequest(options).subscribe((instructeur) => {
        observer.next(instructeur);
      });
    });
  }

  public afmeldenDeelnemerLes(
    abonnementId: string,
    lesId: string,
    alleLessenAfmelden: boolean,
    negeerTelateAfmelding: boolean
  ): Observable<void> {
    const options = new RequestOptions();
    options.controller = 'Instructeur';
    options.endpoint = 'AfmeldenDeelnemerLes';
    if (alleLessenAfmelden) {
      options.successMessage = 'Afgemeld voor deze en alle opvolgende lessen.';
    } else if (negeerTelateAfmelding) {
      options.successMessage = 'Afmelding omgezet naar een normale afmelding.';
    }
    options.data = {
      AbonnementId: abonnementId,
      LesId: lesId,
      AlleLessenAfmelden: alleLessenAfmelden,
      NegeerTelateAfmelding: negeerTelateAfmelding,
    };

    return new Observable<void>((observer) => {
      this.request.SendRequest(options, null, (err) => {
        if (err) {
          observer.error(err);
        }
      }).subscribe({
        next: () => observer.next(),
        error: (error) => observer.error(error)
      });
    });
  }

  public undoAfmeldingDeelnemerLes(abonnementId: string, lesId: string): Observable<void> {
    const options = new RequestOptions();
    options.controller = 'Instructeur';
    options.endpoint = 'UndoAfmeldingDeelnemerLes';
    options.successMessage = 'Afmelding ongedaan gemaakt.';
    options.data = {
      AbonnementId: abonnementId,
      LesId: lesId,
    };

    return new Observable<void>((observer) => {
      this.request.SendRequest(options, null, (err) => {
        if (err) {
          observer.error(err);
        }
      }).subscribe({
        next: () => observer.next(),
        error: (error) => observer.error(error)
      });
    });
  }

  public afmeldenLesInstructeur(
    lidid: string,
    lesid: string,
    aboId: string,
    status: string,
    teLateAfmelding: boolean,
    vasteDeelnameVerwijderen = false
  ): Observable<AanmeldenLes[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "AfmeldenLes";
    if (vasteDeelnameVerwijderen) {
      options.successMessage = 'Afgemeld voor deze en alle opvolgende lessen.';
    }
    options.data = {
      abonnement: aboId,
      lidid: lidid,
      les: lesid,
      isvastedeelname: false,
      status: status,
      vastedeelnameverwijderen: vasteDeelnameVerwijderen,
      teLateAfmelding: teLateAfmelding
    }

    return new Observable<AanmeldenLes[]>((observer) => {
      this.request.SendRequest(options, null, (err) => {
        if (err) {
          observer.error(err);
        }
      }).subscribe({
        next: (les) => observer.next(les),
        error: (error) => observer.error(error)
      });
    });
  }

  public aanmeldenLesInstructeur(datum: Date): Observable<AanmeldenLes[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "AanmeldenLes";
    options.successMessage = "Lid aangemeld aan de les!";
    options.data = {
      lidid: this.globalService.lidId,
      datum: datum,
      isgastaanmelding: false,
      isvastedeelname: this.globalService.vasteDeelname,
      les: this.globalService.lesId
    }

    return new Observable<AanmeldenLes[]>((observer) => {
      this.request.SendRequest(options).subscribe({
        next: (les) => observer.next(les),
        error: (error) => observer.error(error)
      })
    })
  }

  public instructeurBericht(subject: string, message: string, emailNotification: boolean, pushNotification: boolean, deelnemers: DeelnemersLes[]): Observable<any> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "InstructeurBericht";
    options.successMessage = "Bericht verstuurd!";
    options.data = {
      subject: subject,
      message: message,
      emailNotification: emailNotification,
      pushNotification: pushNotification,
      deelnemers: deelnemers,
    };

    return new Observable((observer) => {
      this.request.SendRequest(options).subscribe((response) => {
        observer.next(response);
      });
    });
  }

  public aanmeldenLes(datum: Date, toastMessage: string): Observable<AanmeldenLes[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "AanmeldenLes";
    options.successMessage = toastMessage;
    options.data = {
      lidid: this.globalService.getLid().Id,
      datum: datum,
      isgastaanmelding: false,
      isvastedeelname: this.globalService.vasteDeelname,
      les: this.globalService.lesId
    }

    return new Observable<AanmeldenLes[]>((observer) => {
      this.request.SendRequest(options).subscribe({
        next: (les) => observer.next(les),
        error: (error) => observer.error(error)
      });
    })
  }

  public getInstructeurLessen(date: Date): Observable<InstructeurLessen[]> {
    const options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "GetInstructeurLessen_v3";
    options.params = {
      datum: date.toISOString()
    };
    return new Observable<InstructeurLessen[]>((observer) => {
      this.request.SendRequest(options).subscribe((instructeur) => {
        observer.next(instructeur);
      })
    });
  }

  public aanmeldenWachtlijstExtra(): Observable<AanmeldenLes[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "AanmeldenWachtlijstExtra";
    options.successMessage = "Je bent toegevoegd aan de wachtlijst.";
    options.data = {
      les: this.globalService.lesId
    };
    return new Observable<AanmeldenLes[]>((observer) => {
      this.request.SendRequest(options).subscribe((les) => {
        observer.next(les);
      });
    });
  }

  public getDeelnemersOpLes(lesid: string): Observable<DeelnemersLes[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "GetDeelnemersOpLes";
    options.params = {
      les: lesid
    };
    return new Observable<DeelnemersLes[]>((observer) => {
      this.request.SendRequest(options).subscribe((deelnemer) => {
        observer.next(deelnemer);
      });
    });
  }

  public getWachtlijstOpLes(lesid: string): Observable<DeelnemersLes[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "GetWachtlijstOpLes";
    options.params = {
      les: lesid
    };
    return new Observable<DeelnemersLes[]>((observer) => {
      this.request.SendRequest(options).subscribe((deelnemer) => {
        observer.next(deelnemer);
      });
    });
  }

  public GetLeden(searchText: string): Observable<SearchLid[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "GetLeden";
    options.params = {
      searchText: searchText,
    }
    return new Observable<SearchLid[]>((observer) => {
      this.request.SendRequest(options).subscribe((searchLid) => {
        observer.next(searchLid);
      });
    });
  }

  public aanmeldenWachtlijstVast(): Observable<AanmeldenLes[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "AanmeldenWachtlijstVast";
    options.data = {
      les: this.globalService.lesId
    };
    return new Observable<AanmeldenLes[]>((observer) => {
      this.request.SendRequest(options).subscribe((les) => {
        observer.next(les);
      });
    });
  }

  public checkinDeelnemer(deelnemerId: string, lesId: string, type: string, aanwezig: boolean, aanwezigoriginele: boolean): Observable<AanmeldenLes[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "CheckinDeelnemer";
    options.data = {
      Id: deelnemerId,
      AanwezigOrigineleWaarde: aanwezigoriginele,
      AanmeldId: deelnemerId,
      GeplandeActiviteitId: lesId,
      Aanwezig: aanwezig,
      type: type
    };
    return new Observable<AanmeldenLes[]>((observer) => {
      this.request.SendRequest(options).subscribe((instructeur) => {
        observer.next(instructeur);
      });
    });
  }

  public afspraakVerwijderen(options?: {
    abonnementId?: string | null;
    geplandeActiviteitId?: string | null;
    status?: string | null;
    vorderingId?: string | null;
    suppressErrorToast?: boolean;
  }): Observable<AanmeldenLes[]> {
    const geplandeActiviteitId = options?.geplandeActiviteitId || this.globalService.lesId;
    const abonnementId = options?.abonnementId || this.globalService.abonnementId || null;
    const requestOptions: RequestOptions = new RequestOptions();
    requestOptions.controller = 'LesReserveren';
    requestOptions.endpoint = 'AfspraakVerwijderen_v2';
    requestOptions.successMessage = 'Je bent afgemeld van deze afspraak.';
    requestOptions.suppressErrorToast = options?.suppressErrorToast === true;
    // Geen lege GUID: de server doet NullReference bij ongeldig/ontbrekend abonnement.
    requestOptions.data = {
      abonnement: abonnementId,
      GeplandeActiviteitId: geplandeActiviteitId,
      les: geplandeActiviteitId,
      lidid: Authentication.GetLid()?.Id,
      status: options?.status || this.globalService.activiteitStatus,
      vastedeelnameverwijderen: false,
    };
    if (options?.vorderingId) {
      requestOptions.data['VorderingId'] = options.vorderingId;
    }
    return new Observable<AanmeldenLes[]>((observer) => {
      this.request.SendRequest(requestOptions).subscribe({
        next: () => observer.next([]),
        error: (error) => observer.error(error)
      });
    });
  }

  public afmeldenLes(
    toastMessage: string,
    options?: {
      abonnementId?: string | null;
      lesId?: string | null;
      status?: string | null;
      teLateAfmelding?: boolean;
      vasteDeelnameVerwijderen?: boolean;
      suppressErrorToast?: boolean;
    }
  ): Observable<AanmeldenLes[]> {
    const requestOptions: RequestOptions = new RequestOptions();
    requestOptions.controller = 'LesReserveren';
    requestOptions.endpoint = 'AfmeldenLes';
    requestOptions.successMessage = toastMessage;
    requestOptions.suppressErrorToast = options?.suppressErrorToast === true;
    const abonnementId = options && 'abonnementId' in options
      ? options.abonnementId
      : this.globalService.abonnementId;
    const vasteDeelnameVerwijderen = options?.vasteDeelnameVerwijderen ?? this.globalService.vasteDeelname;
    requestOptions.data = {
      abonnement: abonnementId ?? null,
      vastedeelnameverwijderen: vasteDeelnameVerwijderen,
      status: options?.status || this.globalService.activiteitStatus,
      les: options?.lesId || this.globalService.lesId,
      lidid: Authentication.GetLid()?.Id,
      teLateAfmelding: options?.teLateAfmelding === true,
    };
    return new Observable<AanmeldenLes[]>((observer) => {
      this.request.SendRequest(requestOptions).subscribe({
        next: (les) => observer.next(les),
        error: (error) => observer.error(error)
      });
    });
  }

  public saveLes(aanwezig: string): Observable<AanmeldenLes[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "SaveLes";
    options.successMessage = "Les opgeslagen";
    options.data = {
      AanwezigGeteld: aanwezig,
      Id: this.globalService.saveId
    };
    return new Observable<AanmeldenLes[]>((observer) => {
      this.request.SendRequest(options).subscribe((instructeur) => {
        observer.next(instructeur);
      });
    });
  }

  public afmeldenWachtLijstExtra(): Observable<AanmeldenLes[]> {
    const options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "AfmeldenWachtlijstExtra";
    options.successMessage = "Je bent afgemeld van de wachtlijst.";
    options.data = {
      abonnement: this.globalService.abonnementId,
      vastedeelnameverwijderen: this.globalService.vasteDeelname,
      status: this.globalService.activiteitStatus,
      les: this.globalService.lesId
    };
    
    return this.request.SendRequest(options);
  }

  public afmeldenWachtlijstVast(): Observable<AanmeldenLes[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "AfmeldenWachtlijstVast";
    options.successMessage = "Je bent afgemeld van de wachtlijst.";
    options.data = {
      abonnement: this.globalService.abonnementId,
      vastedeelnameverwijderen: this.globalService.vasteDeelname,
      status: this.globalService.activiteitStatus,
      les: this.globalService.lesId
    }
    return new Observable<AanmeldenLes[]>((observer) => {
      this.request.SendRequest(options).subscribe((les) => {
        observer.next(les);
      })
    })
  }

  public nieuweAfspraakOpslaan(aantalBlokken: number, startTijd: string, eindTijd: string, lesmomentId: string, prijsvariatie: string): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "LesReserveren";
    options.endpoint = "NieuweAfspraakOpslaan";
    options.successMessage = "Je bent aangemeld voor deze afspraak.";
    options.data = {
      AantalBlokken: aantalBlokken,
      StartTijd: startTijd,
      EindTijd: eindTijd,
      LesmomentId: lesmomentId,
      Prijsvariatie: prijsvariatie
    }

    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe({
        next: (result) => observer.next(result),
        error: (error) => observer.error(error)
      });
    });
  }

  public getAnonymousLesResult(startTijd: string): Observable<AnonymousLesResult> {
    const emptyGuid = '00000000-0000-0000-0000-000000000000';
    const toGuid = (value: string | null | undefined): string => {
      const v = (value || '').trim();
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v)
        ? v
        : emptyGuid;
    };

    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetAnonymousLesResult_v2";
    options.params = {
      activiteitId: toGuid(this.globalService.lesId),
      medewerkerId: toGuid(this.globalService.medewerkerId),
      activiteitInfoId: toGuid(this.globalService.activiteitInfoId),
      lidId: toGuid(this.globalService.getLid()?.Id),
      start: startTijd
    }
    return new Observable<AnonymousLesResult>((observer) => {
      this.request.SendRequest(options).subscribe((les) => {
        observer.next(les);
      })
    })
  }

  public getAnonymousActiviteitInfo(page: number = 1): Observable<AnonymousActiviteitInfo[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetActiviteitInfo";
    options.params = {
      lidId: this.globalService.getLid().Id,
      page: page
    }
    return new Observable<AnonymousActiviteitInfo[]>((observer) => {
      this.request.SendRequest(options).subscribe((activiteitInfo) => {
        observer.next(activiteitInfo);
      })
    })
  }
  public getActiviteitInfoById(activiteitInfoId: string): Observable<AnonymousActiviteitInfo> {
    const options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "GetActiviteitInfoById";
    options.params = {
      infoItemId: activiteitInfoId
    };

    return this.request.SendRequest(options);
  }


  /**
   * @deprecated Use ChatService.loadChats() instead.
   */
  public getChats(): Observable<ChatGroup[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "ChatMessages";
    options.endpoint = "GetChatMessages";
    options.params = {
      lidId: this.globalService.getLid().Id,
    }
    return new Observable<ChatGroup[]>((observer) => {
      this.request.SendRequest(options).subscribe((chat) => {
        observer.next(chat);
      })
    })
  }

  /**
   * @deprecated Use ChatService.openChat() instead.
   */
  public getMessages(id: string): Observable<ChatMessage[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "ChatMessages";
    options.endpoint = "GetChatMessages";
    options.params = {
      lidId: this.globalService.getLid().Id,
      chatId: id
    };

    return this.request.SendRequest(options);
  }

  public allowChangeProfileImage(): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "AllowProfileImageEdit";
    return this.request.SendRequest(options);
  }

  public changeProfileImage(image): Observable<Image[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "SaveProfileImage";
    options.data = {
      Image: image
    };
    return new Observable<Image[]>((observer) => {
      this.request.SendRequest(options).subscribe((image) => {
        observer.next(image);
      });
    });
  }

  public GetFilteredOptions(): Observable<GetFilteredOptions[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetFilteredCatOptionsEnhancedByMode";
    options.params = {
      categoryFieldName: "[Categorie%201]",
      cat1Id: this.globalService.cat1,
      cat2Id: this.globalService.cat2,
      cat3Id: this.globalService.cat3,
      plaats: "",
      startDag: "",
      inschrijfModus: "1",
    }

    return new Observable<GetFilteredOptions[]>((observer) => {
      this.request.SendRequest(options).subscribe((tijdelijkeStopData) => {
        observer.next(tijdelijkeStopData);
      });
    });
  }

  public GetFilteredOptions2(): Observable<GetFilteredOptions[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetFilteredCatOptionsEnhancedByMode";
    options.params = {
      categoryFieldName: "[Categorie%202]",
      cat1Id: this.globalService.cat1,
      cat2Id: this.globalService.cat2,
      cat3Id: this.globalService.cat3,
      plaats: "",
      startDag: "",
      inschrijfModus: "1",
    }

    return new Observable<GetFilteredOptions[]>((observer) => {
      this.request.SendRequest(options).subscribe((tijdelijkeStopData) => {
        observer.next(tijdelijkeStopData);
      });
    });
  }

  public GetFilteredOptions3(): Observable<GetFilteredOptions[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetFilteredCatOptionsEnhancedByMode";
    options.params = {
      categoryFieldName: "[Categorie%203]",
      cat1Id: this.globalService.cat1,
      cat2Id: this.globalService.cat2,
      cat3Id: this.globalService.cat3,
      plaats: "",
      startDag: "",
      inschrijfModus: "1",
    }

    return new Observable<GetFilteredOptions[]>((observer) => {
      this.request.SendRequest(options).subscribe((tijdelijkeStopData) => {
        observer.next(tijdelijkeStopData);
      });
    });
  }

  public GetAnonymousAbonnementSummary(kortingscode: string | null): Observable<AnonymousAbonnementSummary> {
    const params: Record<string, string> = {
      abonnementsvorm: this.globalService.abonnementsvormId,
      ingangsdatum: this.globalService.ingangsdatum.toISOString()
    };

    const lidId = this.globalService.getLid()?.Id;
    if (lidId) params["lidId"] = lidId;
    if (kortingscode) params["kortingscode"] = kortingscode;

    const options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetAnonymousAbonnementSummary";
    options.params = params;

    return new Observable<AnonymousAbonnementSummary>((observer) => {
      this.request.SendRequest(options).subscribe((anonymousAbonnement) => {
        observer.next(anonymousAbonnement);
      })
    })
  }

  public GetAddons(): Observable<Addons[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetAddonsByAbonnementsvormId";
    options.data = {
      abonnementsvormId: this.globalService.abonnementsvormId,
      ingangsDatum: this.globalService.ingangsdatum.toISOString()
    }

    return new Observable<Addons[]>((observer) => {
      this.request.SendRequest(options).subscribe((addons) => {
        observer.next(addons);
      })
    })
  }

  public GetSpaarpunten(): Observable<Spaarpunten[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Lid";
    options.endpoint = "GetSpaarpuntenVanLid";

    return new Observable<Spaarpunten[]>((observer) => {
      this.request.SendRequest(options).subscribe((spaarpunten) => {
        observer.next(spaarpunten);
      })
    })
  }

  public GetAddonsByAbonnementsvormId(abonnementsvormId: string, ingangsdatum: string): Observable<Addons[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetAddonsByAbonnementsvormId";
    options.data = {
      abonnementsvormId: abonnementsvormId,
      ingangsDatum: ingangsdatum
    }

    return new Observable<Addons[]>((observer) => {
      this.request.SendRequest(options).subscribe((addons) => {
        observer.next(addons);
      })
    })
  }

  public GenerateAccountFromLid(lidId: string): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "Account";
    options.endpoint = "GenerateAccountFromLidV3";
    options.data = {
      lidId: lidId
    };
    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe((oneOffToken) => {
        observer.next(oneOffToken);
      });
    });
  }

  public GenerateAccountSilentlyFromLid(lidId: string): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "Account";
    options.endpoint = "GenerateAccountSilentlyFromLidV3";
    options.data = {
      lidId: lidId
    };
    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe((oneOffToken) => {
        observer.next(oneOffToken);
      });
    });
  }

  public StartOnlinePaymentWithObject(onlinePaymentData: OnlinePaymentDataContract): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "StartOnlinePayment";
    options.data = onlinePaymentData;
    options.widgetId = this.globalService.widgetId;
    return this.request.SendRequest(options);
  }

  public UpdateBankgegevensVanLid(iban: string, rekeninghouder: string): Observable<AnonymousAbonnementSummary[]> {
    const lid = this.globalService.getLid()!;
    const options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "UpdateBankgegevensVanLid_v2";
    options.suppressErrorToast = true;
    options.data = {
      lidId: lid.Id,
      iban: iban,
      GemachtigdVoorIncasso: this.globalService.incassoChecked,
      naamRekeninghouder: rekeninghouder
    }
    return this.request.SendRequest(options).pipe(
      tap(() => {
        Authentication.UpdateBankGegevens(iban, rekeninghouder, this.globalService.incassoChecked);
      })
    );
  }

  public UpdateBankgegevensVanLidWidget(oneOffToken: string, iban: string, rekeninghouder: string): Observable<AnonymousAbonnementSummary[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Account";
    options.endpoint = "UpdateBankgegevensVanLid_ByOneOffToken";
    options.data = {
      lidId: null,
      iban: iban,
      GemachtigdVoorIncasso: this.globalService.incassoChecked,
      naamRekeninghouder: rekeninghouder,
      oneOffToken: oneOffToken
    }
    options.isAnonymous = true;
    return new Observable<AnonymousAbonnementSummary[]>((observer) => {
      this.request.SendRequest(options).subscribe((anonymousAbonnement) => {
        observer.next(anonymousAbonnement);
        //Authentication.UpdateBankGegevens(this.globalService.lid.IBAN, this.globalService.lid.Naam_rekeninghouder, this.globalService.incassoChecked);
      })
    })
  }

  public GetAnonymousAbonnementSummaryWithParams(lidId: string | null, abonnementsvorm: string, ingangsdatum: Date, kortingscode: string): Observable<AnonymousAbonnementSummary> {
    const options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetAnonymousAbonnementSummary";
    options.params = {
      lidId: lidId,
      abonnementsvorm: abonnementsvorm,
      ingangsdatum: ingangsdatum.toISOString()
    }

    if(kortingscode){
      options.params["kortingscode"] = kortingscode;
    }

    return new Observable<AnonymousAbonnementSummary>((observer) => {
      this.request.SendRequest(options).subscribe((anonymousAbonnement) => {
        observer.next(anonymousAbonnement);
      })
    })
  }

  public GetTransactieStatus(transactieId: string): Observable<GetTransactieModels[]> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Payment";
    options.endpoint = "GetTransactieModels";
    options.params = {
      transactieId: transactieId
    };

    return new Observable<GetTransactieModels[]>((observer) => {
      this.request.SendRequest(options).subscribe((transactie) => {
        observer.next(transactie);
      })
    })
  }

  public GetTransactieId(): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "CreateTransactieId";

    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe((transactieId) => {
        observer.next(transactieId);
      })
    });
  }

  public GetOrder(): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Payment";
    options.endpoint = "GetMSPOrder";
    options.params = {
      transactionId: this.globalService.transactieId
    };

    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe((OrderResponse) => {
        observer.next(OrderResponse);
        this.globalService.mspOrder = OrderResponse;
      })
    });
  }

  public StartIncassoPayment(
    AbonnementsVorm: string,
    AbonnementsVormId: string,
    DigitalSignature: string,
    Addons: Addons[],
    Kortingscode: string | undefined,
    AbonnementsvormType: string,
    Betaalwijze: string
  ): Observable<string> {
    const lid = this.globalService.getLid()!;
    const ingangsDatum = this.globalService.upgradeType == "Downgrade"
      ? (this.globalService.overstapIngangsDatum ?? new Date())
      : new Date();

    const data: any = {
      LidGebruikersnaam: lid.Gebruikersnaam,
      LidId: lid.Id,
      AbonnementsVorm: AbonnementsVorm,
      AbonnementsVormId: AbonnementsVormId,
      AbonnementsvormType: AbonnementsvormType,
      Addons: Addons,
      Ingangsdatum: ingangsDatum,
      DigitalSignature: DigitalSignature,
      LidEmail: lid.E_mail,
      LidIban: lid.IBAN,
      LidNaamRekeningHouder: lid.Naam_rekeninghouder,
      Betaalwijze: Betaalwijze,
      IsSubscriptionChange: this.globalService.abonnementOverstappen
    };

    if (this.globalService.abonnementId) data["CurrentSubscriptionId"] = this.globalService.abonnementId;
    if (this.globalService.abonnementNaam) data["CurrentSubscriptionName"] = this.globalService.abonnementNaam;
    if (Kortingscode) data["Kortingscode"] = Kortingscode;

    const options: RequestOptions = new RequestOptions();
    options.isAnonymous = false;
    options.controller = "Abonnement";
    options.endpoint = "CreateAbonnement";
    options.suppressErrorToast = true;
    options.data = data;

    return this.request.SendRequest(options);
  }

  public StartOnlinePayment(
    Abonnementsvorm: string,
    AbonnementsvormId: string,
    signatureImg: string,
    DirectBetaling: number,
    TransactieId: string,
    Abonnementsgeld: number,
    Inschrijfgeld: number,
    DeelBetaling: number,
    BetaalwijzeEersteVordering: string,
    BetaalwijzeEersteCursusVordering: string,
    TransactieType: number,
    Factuurnummer: string,
    Betaalwijze: string,
    Kortingscode: string | undefined
  ): Observable<string> {
    const lid = this.globalService.getLid()!;
    let options: RequestOptions = new RequestOptions();
    options.isAnonymous = true;
    options.controller = "AnonymousMasterData";
    options.endpoint = "StartOnlinePayment";
    options.data = {
      Abonnementsvorm: Abonnementsvorm,
      AbonnementsvormId: AbonnementsvormId,
      DigitalSignature: signatureImg,
      DirectBetaling: DirectBetaling,
      Ingangsdatum: new Date(),
      LidAchternaam: lid.Naam,
      LidId: lid.Id,
      LidVoornaam: lid.Voornaam,
      TransactieId: TransactieId,
      Abonnementsgeld: Abonnementsgeld,
      Inschrijfgeld: Inschrijfgeld,
      DeelBetaling: DeelBetaling,
      BetaalwijzeEersteVordering: BetaalwijzeEersteVordering,
      BetaalwijzeEersteCursusVordering: BetaalwijzeEersteCursusVordering,
      TransactieType: TransactieType,
      Factuurnummer: Factuurnummer,
      Betaalwijze: Betaalwijze,
      Vorderingen: [],
      Addons: [],
      Kortingscode: Kortingscode
    }

    return new Observable<string>((observer) => {
      this.request.SendRequest(options).subscribe((OnlinePayment) => {
        observer.next(OnlinePayment);
      })
    })
  }

  public OpzeggenAbonnement(): Observable<AnonymousAbonnementSummary[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "OpzeggenAbonnement";
    options.params = {
      abonnementId: this.globalService.abonnementIdVoorOpzeggen,
      opzegDatum: this.todayDate.toISOString()
    };

    return new Observable<AnonymousAbonnementSummary[]>((observer) => {
      this.request.SendRequest(options).subscribe((Opzeggen) => {
        observer.next(Opzeggen);
      })
    })
  }

  public OpzeggenOngedaanAbonnement(): Observable<AnonymousAbonnementSummary[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "OpzeggingOngedaanMakenAbonnement";
    options.params = {
      abonnementId: this.globalService.abonnementIdVoorOpzeggen,
    };

    return new Observable<AnonymousAbonnementSummary[]>((observer) => {
      this.request.SendRequest(options).subscribe((Opzeggen) => {
        observer.next(Opzeggen);
      })
    })
  }

  public CreateAbonnement(): Observable<Leeg[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Abonnement";
    options.endpoint = "CreateAbonnement";
    options.data = {
      AbonnementsvormId: "",
      CurrentSubscriptionId: "",
      DigitalSignature: "",
      IngangsDatum: "",
      LidIBAN: "",
      LidId: this.globalService.getLid().Id
    }
    return new Observable<Leeg[]>((observer) => {
      this.request.SendRequest(options).subscribe((create) => {
        observer.next(create);
      });
    });
  }

  public CreateAbonnementFromObject(abonnementData: CreateAbonnement): Observable<string> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Account";
    options.endpoint = "CreateAbonnement";
    options.isAnonymous = true;
    options.data = abonnementData;
    return this.request.SendRequest(options);
  }

  public WijzigTijdelijkeStop(): Observable<Leeg[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "WijzigTijdelijkeStop";
    options.data = {
      LidId: Authentication.GetLid().Id,
      Reden: "Opschorting gewijzigd door lid via app."
    }
    return new Observable<Leeg[]>((observer) => {
      this.request.SendRequest(options).subscribe((beendigen) => {
        observer.next(beendigen);
      })
    })
  }

  public VerwijderTijdelijkeStop(): Observable<Leeg[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "VerwijderTijdelijkeStop";
    options.data = {
      LidId: Authentication.GetLid().Id,
      Reden: "Opschorting verwijderd door lid via app."
    }
    return new Observable<Leeg[]>((observer) => {
      this.request.SendRequest(options).subscribe((beendigen) => {
        observer.next(beendigen);
      })
    })
  }

  public defaultUrl(tileType: string, ionicUrl: string, betaMode: boolean = true) {
    const themeTile = this.metadataService.getTilesFromCache().find((tile) => {
      if (Utils.isGuid(tileType)) {
        return tile.Id === tileType;
      }

      return tile.Type === tileType
    })!;

    this.setSelectedTile(themeTile);

    // AppDebug.Add("defaultUrl: " + ionicUrl + ", themeTile.Url: " + themeTile.Url, true, true);
    if (themeTile.Url && !(this.getBetaModeFromStorage() && betaMode)) {
      let url = this.getTileUrl(themeTile);
      // AppDebug.Add("getTileUrl: " + url, true, true);

      /** Function to open the webbrowser. */
      let openBrowser = (openUrl: string): void => {
        Browser.removeAllListeners();
        Browser.addListener("browserFinished", () => {
          // Refresh tiles when the user is done with the browser.
          // AppDebug.Add("browserFinished " + (new Date()).toLocaleString(), false, true);
          this.getLiveTileDataAndNextSubject();
        });
        // Open the browser.
        Browser.open({ url: openUrl }).then(() => {
          // AppDebug.Add("Opening " + openUrl + " done.", true, false);
        }, (reason) => {
          // AppDebug.Add("Opening " + openUrl + " failed: " + reason, true, true);
        });
      };

      if (themeTile.LidIdMeegevenAanUrl) {
        // AppDebug.Add("getOneOffToken...", true, true);
        this.getOneOffToken((result) => {
          url += "oneOffToken=" + result + "&";
          // AppDebug.Add("getOneOffToken done: " + result + ", openening url: " + url, true, true);
          openBrowser(url);
        })
      }
      else {
        // AppDebug.Add("LidIdMeegevenAanUrl: " + themeTile.LidIdMeegevenAanUrl + ", openening url: " + url, true, true);
        openBrowser(url);
      }
    }
    else {
      // AppDebug.Add("Navigating " + "/" + ionicUrl, true, true);
      this.router.navigate(["/" + ionicUrl]).then((val) => {
        // AppDebug.Add("Navigate done, fulfilled: " + val, true, true);
      }, (reason) => {
        // AppDebug.Add("Navigate failed, reason: " + reason, true, true);
      });
    }
  }
  // Get betaMode from local storage
  private getBetaModeFromStorage(): boolean {
    const storedValue = localStorage.getItem('betaMode');
    if (storedValue === null) {
      // Default to false if not set
      return false;
    }
    return JSON.parse(storedValue);
  }

  public getTileUrl(themeTile: ThemeTile): string {
    let url = themeTile.Url;
    let lid = this.globalService.getLid();


    url += /\?/gm.test(url) ? "&" : "?";

    if (themeTile.Type === "Spaarpunten") {
      let base64: string = `${lid.Lidnr}&${lid.Spaarpunten}&`;
      url += "r=" + btoa(base64) + "&";
    }

    return url;
  }

  public UpdateWorkoutSchemaOefeningDag(workoutSchemaOefeningId: string, dag: string, workoutId: string): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Workout";
    options.endpoint = "UpdateWorkoutSchemaOefeningDag";
    options.data = {
      SchemaOefeningId: workoutSchemaOefeningId,
      Dag: dag,
      WorkoutId: workoutId
    };

    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public getWrappedData(): Observable<WrappedData> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Lid";
    options.endpoint = "LidWrap";
    return new Observable<WrappedData>((observer) => {
      this.request.SendRequest(options).subscribe((data: WrappedData) => {
        observer.next(data);
      });
    });
  }

  public getKpiData(startDate: Date, endDate: Date, vestigingId: string, periodeInterval: string, financieleGroep: string, groeperenPerVestiging: number = 0): Observable<Kpi[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "GetKpis";
    options.timeout = 60000;
    options.data = {
      VestigingId: vestigingId,
      PeriodeInterval: periodeInterval,
      FinancieleGroep: financieleGroep, 
      StartDate: startDate,
      EndDate: endDate,
      GroeperenPerVestiging: groeperenPerVestiging
    };
    return new Observable<Kpi[]>((observer) => {
      this.request.SendRequest(options, null, (error) => {
        observer.error(error);
      }).subscribe((data: Kpi[]) => {
        observer.next(data);
      });
    });
  }

  public saveKpiDoel(vestigingId: string, periode: string, doel: number | null, periodeInterval: string, financieleGroep: string): Observable<boolean> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "SaveKpiDoel";
    options.timeout = 60000;
    options.data = {
      VestigingId: vestigingId,
      Periode: periode,
      Doel: doel,
      PeriodeInterval: periodeInterval,
      FinancieleGroep: financieleGroep
    };
    return new Observable<boolean>((observer) => {
      this.request.SendRequest(options, null, (error) => {
        observer.error(error);
      }).subscribe((success: boolean) => {
        observer.next(success);
      });
    });
  }

  public getKpiPeriodes(): Observable<{Id: string, Naam: string}[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "GetKpiPeriodes";
    return new Observable<{Id: string, Naam: string}[]>((observer) => {
      this.request.SendRequest(options).subscribe((data: {Id: string, Naam: string}[]) => {
        observer.next(data);
      });
    });
  }

  public getKpiFinancieleGroepen(): Observable<{Id: string, Naam: string}[]> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "Instructeur";
    options.endpoint = "GetKpiFinancieleGroepen";
    return new Observable<{Id: string, Naam: string}[]>((observer) => {
      this.request.SendRequest(options).subscribe((data: {Id: string, Naam: string}[]) => {
        observer.next(data);
      });
    });
  }

  public GetLidByOneOffToken(oneOffToken: string): Observable<Lid> {
    let options: RequestOptions = new RequestOptions();
    options.controller = "AnonymousMasterData";
    options.endpoint = "GetLidByOneOffToken";
    options.isAnonymous = true;
    options.widgetId = this.globalService.widgetId;

    options.params = {
      token: oneOffToken
    };
    return new Observable<Lid>((observer) => {
      this.request.SendRequest(options).subscribe((data: Lid) => {
        observer.next(data);
      });
    });
  }
}